import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Autocomplete from "@material-ui/lab/Autocomplete";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import SearchIcon from "@material-ui/icons/Search";
import _ from "lodash";
import "./imagePortalStyle.css";

import {
  clearImages,
  fetchAllSupplierImages,
  setCurrentSearchItem
} from "../../actions";

const ImageSearch = props => {
  const { currentItem } = props.images;
  if (_.isEmpty(props.images.masterItemList)) {
    return <></>;
  } else {
    return (
      <>
        <Autocomplete
          id="ref-number-auto-complete"
          size="small"
          freeSolo
          clearOnEscape
          style={{ width: 180, marginRight: 15 }}
          options={props.images.masterItemList}
          onChange={(event, newValue) => {
            props.setCurrentSearchItem(newValue);
          }}
          value={currentItem}
          renderInput={params => (
            <TextField
              {...params}
              label="Reference Number"
              margin="dense"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
          )}
          renderOption={(option, { inputValue }) => {
            const matches = match(option, inputValue);
            const parts = parse(option, matches);

            return (
              <div>
                {parts.map((part, index) => (
                  <span
                    key={index}
                    style={{ fontWeight: part.highlight ? 700 : 400 }}
                  >
                    {part.text}
                  </span>
                ))}
              </div>
            );
          }}
        />
      </>
    );
  }
};

function mapStateToProps(state) {
  return {
    images: state.imageList,
    user: state.user
  };
}

ImageSearch.propTypes = {
  images: PropTypes.object,
  user: PropTypes.object,
  clearImages: PropTypes.func,
  fetchAllSupplierImages: PropTypes.func,
  setCurrentSearchItem: PropTypes.func
};

export default connect(mapStateToProps, {
  clearImages,
  fetchAllSupplierImages,
  setCurrentSearchItem
})(ImageSearch);
